import toast from "react-hot-toast";

/*
- Default con icono incluido y posición en default (TOP CENTER)
    REACT_HOT_TOAST_SUCCESS("Guardado correctamente");

- Sin icono
    REACT_HOT_TOAST_ERROR("Error silencioso",{ icon:false });

- Icono custom
    REACT_HOT_TOAST_INFO("Modo mantenimiento",{ icon:"🛠️" });

- Warning sin iconos
    REACT_HOT_TOAST_WARNING("Campos incompletos",{ icon:false });

- Posición e Icono
    REACT_HOT_TOAST_ERROR("Archivo inválido", position:"bottom-center", icon:"📂" });

*/

// ------------------------------------------ 🔥 RESOLVER ICONO
const RESOLVE_ICON = (icon) => {
    if (icon === false) return { icon: null };
    if (typeof icon === "string") return { icon };
    if (icon === true) return {}; // usa icono por defecto de success/error
    if (icon) return { icon }; // JSX / ReactNode
    return {};
};

const DEFAULT_POSITION = "top-center";

// ------------------------------------------ 🔥 DEDUPE LOCAL (SIN toast.isActive)
const ACTIVE_TOAST_IDS = new Set();
const RESOLVE_ID = (MESSAGE, TYPE, OPTIONS = {}) => OPTIONS.id || `${TYPE}_${MESSAGE}`;
const RESOLVE_DURATION = (rest = {}) => typeof rest.duration === "number" ? rest.duration : 4000;
const REGISTER_ONCE = (id, rest = {}) => {
    if (ACTIVE_TOAST_IDS.has(id)) return false;
    ACTIVE_TOAST_IDS.add(id);
    if (rest.duration === Infinity) return true;
    const duration = RESOLVE_DURATION(rest);
    setTimeout(() => ACTIVE_TOAST_IDS.delete(id), Math.max(0, duration));
    return true;
};

export const REACT_HOT_TOAST_DISMISS = (id) => {
    if (id) ACTIVE_TOAST_IDS.delete(id);
    return toast.dismiss(id);
};

export const REACT_HOT_TOAST_INFO = (MESSAGE, OPTIONS = {}) => {
    const { icon = false, ...rest } = OPTIONS;
    const id = RESOLVE_ID(MESSAGE, "info", OPTIONS);
    if (!REGISTER_ONCE(id, rest)) return id;
    return toast(MESSAGE, { id, position: DEFAULT_POSITION, ...RESOLVE_ICON(icon), ...rest });
};

export const REACT_HOT_TOAST_ERROR = (MESSAGE, OPTIONS = {}) => {
    const { icon = true, ...rest } = OPTIONS;
    const id = RESOLVE_ID(MESSAGE, "error", OPTIONS);
    if (!REGISTER_ONCE(id, rest)) return id;
    return toast.error(MESSAGE, { id, position: DEFAULT_POSITION, ...RESOLVE_ICON(icon), ...rest });
};

export const REACT_HOT_TOAST_SUCCESS = (MESSAGE, OPTIONS = {}) => {
    const { icon = true, ...rest } = OPTIONS;
    const id = RESOLVE_ID(MESSAGE, "success", OPTIONS);
    if (!REGISTER_ONCE(id, rest)) return id;
    return toast.success(MESSAGE, { id, position: DEFAULT_POSITION, ...RESOLVE_ICON(icon), ...rest });
};

export const REACT_HOT_TOAST_LOADING = (MESSAGE, OPTIONS = {}) => {
    const { icon = true, ...rest } = OPTIONS;
    const id = RESOLVE_ID(MESSAGE, "loading", OPTIONS);
    if (!REGISTER_ONCE(id, { ...rest, duration: Infinity })) return id;
    return toast.loading(MESSAGE, { id, position: DEFAULT_POSITION, ...RESOLVE_ICON(icon), ...rest });
};

export const REACT_HOT_TOAST_WARNING = (MESSAGE, OPTIONS = {}) => {
    const { icon = "⚠️", ...rest } = OPTIONS;
    const id = RESOLVE_ID(MESSAGE, "warning", OPTIONS);
    if (!REGISTER_ONCE(id, rest)) return id;
    return toast(MESSAGE, { id, position: DEFAULT_POSITION, ...RESOLVE_ICON(icon), ...rest });
};
